import BaseCardEmr from '@/screens/Timeline/components/BaseCardEmr';
import useGlobalConfigs from '@/stores/globalConfigs';
import utils from '@/utils';
import dayjs from 'dayjs';
import * as React from 'react';

export interface IEmrInDayProps {
  emrs: IEMRData[];
  range: string;
}

const EmrInDay: React.FC<IEmrInDayProps> = ({ emrs, ...props }) => {
  const date = dayjs(emrs[0]?.date);
  const getEmrViewTimeline = useGlobalConfigs((s) => s.getEmrViewTimeline);
  const listEmrType = getEmrViewTimeline();

  const listEmrSort = utils.customSort({
    arr: emrs,
    order: listEmrType,
    keys: { order: 'type.code', time: 'date' },
    sortTime: 1,
  });

  return (
    <div className="w-[220px] flex-none relative ">
      {/* Date */}
      <div className="flex w-full p-2 pl-4 bg-gray-1 sticky top-0 left-0 z-10">
        <div className="flex items-center bg-black rounded-3xl text-white px-[6px] py-[1px]">
          <div className="text-xs text-center">{date.format('DD/MM/YYYY')}</div>
        </div>
      </div>
      {/* EMR */}

      {listEmrSort.map((e, i: number) => (
        <BaseCardEmr key={i.toString()} emr={e} index={i} />
      ))}
    </div>
  );
};

export default EmrInDay;
